// extracted by mini-css-extract-plugin
export default {"price":"_1-z","onSale":"a2-z","msrpLabelPrice":"b2-z","originalPrice":"c2-z","msrpLabel":"d2-z","percentOff":"e2-z"};